export const features = [
  {
    icon: '/static/features-icons/detailed-reports-icon.svg',
    title: 'Detailed Reports',
    description: "Detailed reports provide a bird's-eye view of your financial health",
  },
  {
    icon: '/static/features-icons/mileage-tracker-icon.svg',
    title: 'Mileage Tracking',
    description: 'GPS-based mileage tracking',
  },
  {
    icon: '/static/features-icons/connect-icon.svg',
    title: 'Connect',
    description: 'Easily connect your bank account and credit cards',
  },
  {
    icon: '/static/features-icons/customer-management-icon.svg',
    title: 'Customer Management',
    description: 'Manage your customers and their contact details',
  },
  {
    icon: '/static/features-icons/chart-of-accounts-icon.svg',
    title: 'Chart of Accounts',
    description: 'Chart of accounts set up for you',
  },
  {
    icon: '/static/features-icons/invoicing-icon.svg',
    title: 'Invoicing',
    description: 'Print or email invoices to customers',
  },
];
